import { Batch, Bundle, ProductionComponentInstance, ProductionGroup } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function get(productionGroupGuid: string) {
  return DesignService.get<ProductionGroup>(`public/productionGroups/${productionGroupGuid}`);
}

export function getForProject(projectGuid: string) {
  return DesignService.get<readonly ProductionGroup[]>(`public/productionGroups/forProject/${projectGuid}`);
}

export function getForOrganization() {
  return DesignService.get<readonly ProductionGroup[]>(`public/productionGroups/forOrganization`);
}

export function getActiveForOrganization() {
  return DesignService.get<readonly ProductionGroup[]>(`public/productionGroups/activeForOrganization`);
}

export function insert(productionGroup: ProductionGroup) {
  return DesignService.post<ProductionGroup>('public/productionGroups', { data: productionGroup });
}

export function update(productionGroup: ProductionGroup) {
  return DesignService.put<ProductionGroup>('public/productionGroups', { data: productionGroup });
}

export function remove(productionGroupGuid: string) {
  return DesignService.delete<ProductionGroup>(`public/productionGroups/${productionGroupGuid}`);
}

interface CreateProductionGroupFromCntRequest {
  readonly projectGuid: string;
  readonly cntContents: string;
  readonly projectId: string;
  readonly projectShortName: string;
  readonly buildingType: string;
  readonly buildingInstance: string;
  readonly level: string;
}

interface CreateProductionGroupFromCntResponse {
  readonly productionGroup: ProductionGroup;
  readonly batches: readonly Batch[];
  readonly productionComponentInstances: readonly ProductionComponentInstance[];
}

export function createProductionGroupFromCnt(createProductionGroupFromCntRequest: CreateProductionGroupFromCntRequest) {
  return DesignService.post<CreateProductionGroupFromCntResponse>(
    'public/productionGroups/createProductionGroupFromCnt',
    {
      data: createProductionGroupFromCntRequest,
    },
  );
}

interface DuplicateProductionGroupRequest {
  readonly guid: string;
  readonly projectId: string;
  readonly projectShortName: string;
  readonly buildingType: string;
  readonly buildingInstance: string;
  readonly level: string;
}

interface DuplicateProductionGroupResponse {
  readonly productionGroup: ProductionGroup;
  readonly batches: readonly Batch[];
  readonly bundles: readonly Bundle[];
  readonly productionComponentInstances: readonly ProductionComponentInstance[];
}

export function duplicate(duplicateProductionGroupRequest: DuplicateProductionGroupRequest) {
  return DesignService.post<DuplicateProductionGroupResponse>('public/productionGroups/duplicate', {
    data: duplicateProductionGroupRequest,
  });
}
